<template>
  <div id="app">

    <div class="nav fixed">
      <div class="content">
        <img id="longi_logo" src="../src/assets/images/Longi_Logo.jpg" />
        <div class="hidden-nav">
          <div class="line line--1"></div>
          <div class="line line--2"></div>
          <div class="line line--3"></div>
        </div>
        <div class="nav_bar">
          <router-link to="/" class="nav_item" active-color="#e60012" data-link="/">首页</router-link>
          <router-link to="/about" class="nav_item" active-color="#e60012" data-link="/about">关于我们</router-link>
          <router-link to="/product" class="nav_item" active-color="#e60012" data-link="/product">产品中心</router-link>
          <router-link to="/anli" class="nav_item" active-color="#e60012" data-link="/anli">经典案例</router-link>
          <router-link to="/partner" class="nav_item" active-color="#e60012" data-link="/partner">合作伙伴</router-link>
          <router-link to="/service" class="nav_item" active-color="#e60012" data-link="/service">品牌服务</router-link>
          <router-link to="/news" class="nav_item" active-color="#e60012" data-link="/news">最新资讯</router-link>
          <router-link to="/Contact" class="nav_item" active-color="#e60012" data-link="/Contact">联系我们</router-link>
          <span class="nav_under"></span>
        </div>
      </div>
      <div class="subMenu">
        <div class="menuBox">
          <div class="menu">
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a href="#/about" class="subLink">品牌故事</a></p>
                <p><a href="#/about?link=2" class="subLink">公司简介</a></p>
                <p><a href="#/about?link=3" class="subLink">企业资质</a></p>
                <p><a href="#/about?link=4" class="subLink">企业文化</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a href="#/instrument" class="subLink">智能仪表</a></p>
                <p><a href="#/engineering" class="subLink">智能工程</a></p>
                <p><a href="#/intelligentDevice" class="subLink">智能设备</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a href="#/anli" class="subLink">智能仪表案例</a></p>
                <p><a href="#/anli_engineering" class="subLink">智能工程案例</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a href="#/partner/partnerInfo/1" class="subLink">东北大学</a></p>
                <p><a href="#/partner/partnerInfo/2" class="subLink">兰州大学</a></p>
                <p><a href="#/partner/partnerInfo/3" class="subLink">中国矿业大学</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a class="subLink" href="#/service">定制服务</a></p>
                <p><a class="subLink" href="#/service">服务承诺</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a class="subLink" href="#/news">新闻资讯</a></p>
                <p><a class="subLink" href="#/employeeStyle">员工风采</a></p>
              </div>
            </div>
            <div class="submenuItem">
              <div class="subLinkItem">
                <p><a href="#/Recruitment" class="subLink">诚聘英才</a></p>
                <p><a href="#/Contact" class="subLink">联系我们</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 80px;">
      <div class="pagetop" v-if="$route.path !== '/'" style="display: none;"></div>
      <div style="width: 100%;background-color: #f9f9f9;padding: 20px 0;" v-if="$route.path !== '/'">
        <div class="breadcrumb" v-if="$route.path !== '/'">
          <el-breadcrumb>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="item in list" :key="item.path + item.name">
              <router-link :to="item">{{ item.meta.breadcrumb }}</router-link>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="skinBox" v-if="onloadFlag"></div>
      <!-- <router-view /> -->
    </div>
    <router-view />
    <div class="mobile_dropDownMenu">
      <div class="mobile_nav_box">
        <ul>
          <li class="mob_nav_item">
            <a href="/#/" class="mob_nav_title" @click="toggleNavCollapse('', 'home')">首页</a>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(0)">
              <a class="mob_nav_title">关于我们</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="/#/about" @click="toggleNavCollapse(0, 'linkItem')">品牌故事</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/about?link=2" @click="toggleNavCollapse(0, 'linkItem')">公司简介</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/about?link=3" @click="toggleNavCollapse(0, 'linkItem')">企业资质</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/about?link=4" @click="toggleNavCollapse(0, 'linkItem')">企业文化</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(1)">
              <a class="mob_nav_title">产品中心</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="/#/instrument" @click="toggleNavCollapse(1, 'linkItem')">智能仪表</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/engineering" @click="toggleNavCollapse(1, 'linkItem')">智能工程</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/intelligentDevice" @click="toggleNavCollapse(1, 'linkItem')">智能设备</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(2)">
              <a class="mob_nav_title">经典案例</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="/#/anli" @click="toggleNavCollapse(2, 'linkItem')">智能仪表案例</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/anli_engineering" @click="toggleNavCollapse(2, 'linkItem')">智能工程案例</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(3)">
              <a class="mob_nav_title">合作伙伴</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="#/partner/partnerInfo/1" @click="toggleNavCollapse(3, 'linkItem')">东北大学</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="#/partner/partnerInfo/2" @click="toggleNavCollapse(3, 'linkItem')">兰州大学</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="#/partner/partnerInfo/3" @click="toggleNavCollapse(3, 'linkItem')">中国矿业大学</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(4)">
              <a class="mob_nav_title">品牌服务</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="#/service" @click="toggleNavCollapse(4, 'linkItem')">定制服务</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="#/service" @click="toggleNavCollapse(4, 'linkItem')">服务承诺</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(5)">
              <a class="mob_nav_title">最新资讯</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="#/news" @click="toggleNavCollapse(5, 'linkItem')">新闻资讯</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="#/employeeStyle" @click="toggleNavCollapse(5, 'linkItem')">员工风采</a>
              </div>
            </div>
          </li>
          <li>
            <div class="mob_nav_item" @click="toggleNavCollapse(6)">
              <a class="mob_nav_title">联系我们</a>
              <svg t="1696835390458" class="mob_nav_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4010" width="18" height="18">
                <path
                  d="M832 469.333333H554.666667V192c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667V469.333333H192c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667H469.333333v277.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V554.666667h277.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z"
                  fill="#221E1F" p-id="4011"></path>
              </svg>
            </div>
            <div class="nav_mob_link_collapse">
              <div class="nav_mob_link_item">
                <a href="/#/recruitment" @click="toggleNavCollapse(6, 'linkItem')" class="mob_nav_title">诚聘英才</a>
              </div>
              <div class="nav_mob_link_item">
                <a href="/#/Contact" @click="toggleNavCollapse(6, 'linkItem')" class="mob_nav_title">联系我们</a>
              </div>
            </div>
          </li>
        </ul>
        <div>
          <img src="../src/assets/images/EW6A0022.jpg" style="width:100%;height:200px;margin-top: 20px;" />
        </div>
      </div>
    </div>

    <footer>
      <div class="footer_container">
        <div class="footer_main">
          <div class="footer_nav">
            <div class="footer_group">
              <div class="footer_nav_title"><a>关于我们</a></div>
              <div class="footer_nav_item"><a href="/#/about" @click="activeNav">品牌故事</a></div>
              <div class="footer_nav_item"><a href="/#/about?link=2" @click="activeNav">公司简介</a></div>
              <div class="footer_nav_item"><a href="/#/about?link=3" @click="activeNav">企业资质</a></div>
              <div class="footer_nav_item"><a href="/#/about?link=4" @click="activeNav">企业文化</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title">产品中心</div>
              <div class="footer_nav_item"><a href="/#/instrument" @click="activeNav">智能仪表</a></div>
              <div class="footer_nav_item"><a href="/#/engineering" @click="activeNav">智能工程</a></div>
              <div class="footer_nav_item"><a href="/#/intelligentDevice" @click="activeNav">智能设备</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title">经典案例</div>
              <div class="footer_nav_item"><a href="/#/anli" @click="activeNav">智能仪表案例</a></div>
              <div class="footer_nav_item"><a href="/#/anli_engineering" @click="activeNav">智能工程案例</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title">合作伙伴</div>
              <div class="footer_nav_item"><a href="/#/partner/partnerInfo/1" @click="activeNav">东北大学</a></div>
              <div class="footer_nav_item"><a href="/#/partner/partnerInfo/2" @click="activeNav">兰州大学</a></div>
              <div class="footer_nav_item"><a href="/#/partner/partnerInfo/3" @click="activeNav">中国矿业大学</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title"><a>品牌服务</a></div>
              <div class="footer_nav_item"><a href="#/service" @click="activeNav">定制服务</a></div>
              <div class="footer_nav_item"><a href="#/service" @click="activeNav">服务承诺</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title"><a>最新资讯</a></div>
              <div class="footer_nav_item"><a href="#/news" @click="activeNav">新闻资讯</a></div>
              <div class="footer_nav_item"><a href="#/employeeStyle" @click="activeNav">员工风采</a></div>
            </div>
            <div class="footer_group">
              <div class="footer_nav_title"><a>联系我们</a></div>
              <div class="footer_nav_item"><a href="/#/recruitment" @click="activeNav">诚聘英才</a></div>
              <div class="footer_nav_item"><a href="/#/Contact" @click="activeNav">联系我们</a></div>
            </div>
          </div>
          <div class="footer_aside">
            <div class="footer_logo"><img src="../src/assets/images/logo_line.png" style="width: 100%;height: 100%;" />
            </div>
            <div class="footer_qrCode"><img src="../src/assets/images/wechat_code.png"
                style="width: 100%;height: 100%;" />
            </div>
          </div>
        </div>
        <div class="footer_main_mobile">
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(0, 'f')">
            <div class="footer_mob_title">
              关于我们
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="/#/about">品牌故事</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/about?link=2">公司简介</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/about?link=3">企业资质</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/about?link=4">企业文化</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(1, 'f')">
            <div class="footer_mob_title">
              产品中心
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="/#/instrument">智能仪表</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/engineering">智能工程</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/intelligentDevice">智能设备</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(2, 'f')">
            <div class="footer_mob_title">
              经典案例
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="/#/anli">智能仪表案例</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/anli_engineering">智能工程案例</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(3, 'f')">
            <div class="footer_mob_title">
              合作伙伴
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="#/partner/partnerInfo/1">东北大学</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="#/partner/partnerInfo/2">兰州大学</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="#/partner/partnerInfo/3">中国矿业大学</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(4, 'f')">
            <div class="footer_mob_title">
              品牌服务
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="#/service">定制服务</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="#/service">服务承诺</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(5, 'f')">
            <div class="footer_mob_title">
              最新资讯
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse">
            <div class="footer_mob_link_item">
              <a href="#/news">新闻资讯</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="#/employeeStyle">员工风采</a>
            </div>
          </div>
          <div class="footer_mob_group dropdown-toggle" @click="toggleFooterCollapse(6, 'f')">
            <div class="footer_mob_title">
              联系我们
            </div>
            <svg t="1694505134974" class="footer_icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4011" data-spm-anchor-id="a313x.search_index.0.i1.4fef3a81TKSgOW"
              width="55" height="55">
              <path
                d="M176.512 376.224a64 64 0 0 1 109.248-45.248l226.208 226.272 226.272-226.272a64 64 0 1 1 90.496 90.496l-271.52 271.52a63.936 63.936 0 0 1-90.464 0l-271.488-271.52a63.68 63.68 0 0 1-18.752-45.248z"
                fill="#ffffff" p-id="4012"></path>
            </svg>
          </div>
          <div class="footer_mob_link_collapse" ref="link_collapse">
            <div class="footer_mob_link_item">
              <a href="/#/recruitment">诚聘英才</a>
            </div>
            <div class="footer_mob_link_item">
              <a href="/#/Contact">联系我们</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="footer_btm_container">
          <div class="footer_bottom_group">
            <p>Copyright 沈阳隆基智能技术研究有限公司 All Rights Reserved</p>
            <span>
              <img src="../src/assets/images/备案图标.png" style="vertical-align: middle;" />
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202001018" target="_blank"
                class="footer_beian">辽公网安备21011202001018号</a>
            </span>
            <a class="m_beian footer_beian" href="http://beian.miit.gov.cn/" target="_blank">辽ICP备2022009668号-2</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<!-- <template lang="jade">
#app
  router-view


</template> -->

<script>
import { RouterView } from "vue-router";
import axios from "./router/http";

export default {
  name: "App",
  computed: {
    list() {
      this.$route.matched.shift(); //删除数组中第一项首页
      return this.$route.matched;
    }
  },
  created() {
    // 在组件创建后执行操作
    this.$nextTick(() => {
      // 在 DOM 渲染完成后执行操作
      console.log('Router-view has loaded.');
    });
  },
  data() {
    return {
      appurl: '',
      transitionName: '',
      activeIndex: '/',
      imgUrl: '',
      onloadFlag: true,
    };
  },
  created: function () {

    //手机端右上菜单展开
    this.$nextTick(() => {

      const body = document.querySelector('body')
      const mobile_nav = document.querySelector('.hidden-nav');
      var lineOne = document.querySelector('.line--1');
      var lineTwo = document.querySelector('.line--2');
      var lineThree = document.querySelector('.line--3');
      const mobile_dropDownMenu = document.querySelector('.mobile_dropDownMenu');
      const mob_nav_Elements = document.querySelectorAll('.nav_mob_link_collapse');
      const mob_nav_Icon = document.querySelectorAll('.mob_nav_icon');

      mobile_nav.addEventListener('click', () => {
        lineOne.classList.toggle('line-cross');
        lineTwo.classList.toggle('line-fade-out');
        lineThree.classList.toggle('line-cross');
        mobile_dropDownMenu.classList.toggle('mobile_dropDownMenu--show');

        mob_nav_Icon.forEach(icon => {
          icon.classList.remove('mob_nav_icon_rotate');
        });
        mob_nav_Elements.forEach((element) => {
          element.style.height = '0px';
        })

        //禁止页面滚动
        body.classList.toggle('body-over-hidden');
      })

    })

  },
  methods: {
    //subLink隐藏
    hiddenSubLink() {
      const items = document.querySelectorAll('.subLink');
      const subMenu = document.querySelector('.subMenu');

      items.forEach((item) => {
        item.addEventListener('click', () => {
          subMenu.style.height = '0px';
        });
      });
      subMenu.style.height = '0px';
    },
    //navBar切换激活状态方法
    activeNav() {
      const under_bar = document.querySelector('.nav_under');
      const items = document.querySelectorAll('.nav_item');
      const footerItems = document.querySelectorAll('.footer_nav_item');
      // const subMenu = document.querySelector('.subMenu');
      let activeItem = null;

      setTimeout(() => {
        activeItem = document.querySelector('.router-link-exact-active');
        if (activeItem) {
          handle(activeItem);
        }
      }, 100);

      function handle(e) {
        items.forEach((item) => {
          item.classList.remove('is-active');
          item.removeAttribute('style');
        });

        under_bar.style.width = `${e.offsetWidth}px`;
        under_bar.style.left = `${e.offsetLeft}px`;
        under_bar.style.backgroundColor = e.getAttribute('active-color');

        e.classList.add('is-active');
        e.style.color = e.getAttribute('active-color');
      }

      items.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          handle(e.target);
          this.hiddenSubLink();
          activeItem = e.target;
        });
      });
    },
    showSubMenu() {

      const items = document.querySelectorAll('.nav_item');
      const subMenu = document.querySelector('.subMenu');

      subMenu.addEventListener('mouseleave', (e) => {
        subMenu.style.height = '0px';
      });

      function show() {
        subMenu.style.height = '320px';
      };

      items.forEach((item, index) => {
        item.addEventListener('mouseenter', (e) => {
            show();
        })
      });

    },

    //手机nav展开方法
    toggleNavCollapse(index, cla) {
      const mob_nav_Icon = document.querySelectorAll('.mob_nav_icon');
      const mob_nav_Elements = document.querySelectorAll('.nav_mob_link_collapse');
      const mobile_dropDownMenu = document.querySelector('.mobile_dropDownMenu');
      var lineOne = document.querySelector('.line--1');
      var lineTwo = document.querySelector('.line--2');
      var lineThree = document.querySelector('.line--3');
      var bodyElement = document.body;

      if (cla == 'linkItem' || cla == 'home') {
        lineOne.classList.toggle('line-cross');
        lineTwo.classList.toggle('line-fade-out');
        lineThree.classList.toggle('line-cross');
        mobile_dropDownMenu.classList.toggle('mobile_dropDownMenu--show');
        //禁止页面滚动
        bodyElement.classList.toggle('body-over-hidden');
      }

      // 移除所有元素的旋转类
      mob_nav_Icon.forEach(icon => {
        icon.classList.remove('mob_nav_icon_rotate');
      });

      mob_nav_Elements.forEach((element, i) => {
        if (i === index) {
          element.style.height = element.style.height === '0px' ? element.scrollHeight + 'px' : '0px';

          // 如果当前元素展开，添加旋转类 footerElements的索引与footerIcon的索引相同
          if (element.style.height === element.scrollHeight + 'px') { // 判断是否展开
            mob_nav_Icon[i].classList.add('mob_nav_icon_rotate');
          }
        } else {
          element.style.height = '0px'; // 其他元素高度设置为0
        }
      });
    },

    //手机footer展开方法

    toggleFooterCollapse(index, type, cla) {   // index 菜单栏项索引值 ， type n=顶部导航栏 / f=底部导航栏 , cla 判断为几级元素
      this.$nextTick(() => {

        const footerElements = document.querySelectorAll('.footer_mob_link_collapse');
        const footerIcon = document.querySelectorAll('.footer_icon');

        // 移除所有元素的旋转类
        footerIcon.forEach(icon => {
          icon.classList.remove('icon_rotate');
        });

        footerElements.forEach((element, i) => {
          if (i === index) {
            element.style.height = element.style.height === '0px' ? element.scrollHeight + 'px' : '0px';

            // 如果当前元素展开，添加旋转类 footerElements的索引与footerIcon的索引相同
            if (element.style.height === element.scrollHeight + 'px') { // 判断是否展开
              footerIcon[i].classList.add('icon_rotate');
            }
          } else {
            element.style.height = '0px'; // 其他元素高度设置为0
          }
        });
      });
    }
  },
  mounted() {
    this.toggleNavCollapse();
    this.toggleFooterCollapse();
    this.activeNav();
    this.showSubMenu();
    this.hiddenSubLink();

    this.$router.onReady(() => {
      this.onloadFlag = false;
    });

  },
  watch: {
    $route(to, from) {  //监听路由发生变化时，导航栏切换激活状态
      // console.log(to.path); //目标路径
      this.activeNav();
    }
  },
  components: { RouterView }
};
</script>

<!-- <style src="../src/assets/css/home.css"></style> -->

<style>
@import "./../static/css/public.min.css";

body {
  padding: 0;
  margin: 0;
}

html,
body,
div,
span,
iframe,
blockquote,
pre,
a,
address,
big,
cite,
code,
del,
em,
font,
img,
ins,
small,
strong,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend {
  margin: 0;
  padding: 0;
}

html,
body,
div,
p,
a,
h1,
h2,
h3,
h4,
h5,
li,
ol,
ul,
strong,
span {
  font-family: "微软雅黑";
}

li,
ol,
ul {
  list-style: none outside;
}

:focus {
  outline: 0;
}

a img {
  border: 0;
}

a {
  text-decoration: none;
}

img {
  vertical-align: middle;
}

table {
  empty-cells: show;
}

ins {
  text-decoration: none;
}

del {
  text-decoration: line-through;
}

em {
  font-style: normal;
}

button::-moz-focus-inner,
input[type="reset"]::-moz-focus-inner,
input[type="button"]::-moz-focus-inner,
input[type="submit"]::-moz-focus-inner,
input[type="file"]>input[type="button"]::-moz-focus-inner {
  border: 0;
  padding: 0;
}

a {
  transition: color 0.4s ease-in-out;
  -moz-transition: color 0.4s ease-in-out;
  -webkit-transition: color 0.4s ease-in-out;
  -o-transition: color 0.4s ease-in-out;
}

* {
  font-family: "Helvetica";
  box-sizing: border-box;
}

.pagetop {
  width: 100%;
  height: 55vh;
  background-size: 100% 100%;
  background-position: center center;
  background-color: #f9f9f9;
}

.breadcrumb {
  width: 70%;
  margin: 0 auto;
  background-color: #f9f9f9;
  height: 30px;
  display: flex;
  align-items: center;
}

.pagetop h1 {
  margin: 0;
  line-height: 500px;
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.pos_r {
  position: relative;
}

.pos_a {
  position: absolute;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.overh {
  overflow: hidden;
}

.link_footer {
  color: #fff
}

.link_footer:hover {
  color: #ccc
}

.line-group {
  >h3 {
    font-size: 34px;
    font-weight: normal;
    color: #333333;
    text-align: center;
    margin: 20px 0;
  }
}

.top-cover {
  padding-top: 9%;
  text-align: center;
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1320px;

  h1 {
    font-size: 42px;
    color: #fff;
  }

  span {
    width: 165px;
    height: 1px;
    background-color: #fff;
    display: block;
    margin: 16px auto 0;
  }

  p {
    font-size: 22px;
    color: #fff;
    margin-top: 32px;
    display: block;
  }
}

.el-menu-item {
  font-size: 16px !important;
}

.copyright {
  background: #125688;
  color: #fff;
  text-align: center;
  padding: 10px 0;
}

@media all and (max-width:768px) {
  .breadcrumb {
    width: 85%;
  }
  .pagetop {
    background-size: cover;
    height: 320px;
  }
}
</style>

<style>
.body-over-hidden {
  overflow: hidden;
  /* 禁止页面滚动 */
}
</style>

<style scoped>
.mob_nav_item>a {
  font-weight: 500;
  color: #000;
}

.nav_mob_link_item>a {
  font-weight: 500;
  color: #000;
}

.footer_mob_link_item>a {
  color: #fff;
  font-weight: 500;
}

.footer_nav_item>a {
  color: #fff;
  font-weight: 500;
}

.mob_nav_title:visited,
.nav_mob_link_item>a:visited {
  color: #000;
  font-weight: 500;
}

.footer_mob_link_item>a:visited {
  color: #fff;
  font-weight: 500;
}
</style>

<!--<style>-->
<!--@import "../src/assets/css/home.css";-->
<!--@import "../src/assets/css/home_mobile.css";-->
<!--@import "../src/assets/css/mobile_navLine.css";-->
<!--</style>-->

<style src="../src/assets/css/home.css" scoped></style>
<style src="../src/assets/css/home_mobile.css" scoped></style>
<style src="../src/assets/css/mobile_navLine.css" scoped></style>
<style src="../src/assets/css/footer.css"></style>



// WEBPACK FOOTER //
// src/App.vue